import { render, staticRenderFns } from "./CompetencyDetail.vue?vue&type=template&id=0f418ffe&scoped=true"
import script from "./CompetencyDetail.vue?vue&type=script&lang=js"
export * from "./CompetencyDetail.vue?vue&type=script&lang=js"
import style0 from "./CompetencyDetail.vue?vue&type=style&index=0&id=0f418ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f418ffe",
  null
  
)

export default component.exports